"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const CoreContext_1 = require("../../contexts/CoreContext");
const TranslationService_1 = require("../../services/TranslationService");
/*
* Trans component is used to styling translations, with translation keys that have placeholders to position inner subtext.
* A subtext is a separate translation key that reflect to a consumed child from Trans component.
* */
class Trans extends React.Component {
    render() {
        let translation;
        let tokenizedTranslation;
        return (React.createElement(CoreContext_1.CoreContextConsumer, null, ({ language, languageBundle }) => (translation = TranslationService_1.default.translate(this.props.i18n, languageBundle, language),
            tokenizedTranslation = this.splitTranslationToTokens(translation),
            this.constructInterpolatedArray(tokenizedTranslation))));
    }
    /**
     * Constructs and returns the interpolated text as a array, based on the Array param and the component's children.
     * @return Array<ReactNode|string> - an array of strings or ReactNodes that can be styled.
     * @param tokenizedTranslation - tokenized translation with TranslationToken objects.
     */
    constructInterpolatedArray(tokenizedTranslation) {
        const children = React.Children.toArray(this.props.children);
        return tokenizedTranslation.map((translationToken) => {
            if (translationToken.isPlaceholder) {
                return children[translationToken.placeholderIdx];
            }
            return translationToken.token;
        });
    }
    /**
     * Returns a split array of a string based on <></> tag, where each object has a string token,
     * if the token is a placeholder and what's the placeholder index on the whole translation.
     * @param translation - a translation string which includes placeholders for styling subtext.
     * @return TranslationToken[] - an array of TranslationToken split from the translation.
     */
    splitTranslationToTokens(translation) {
        return translation.split(/(<[0-9]+>[^<]*<\/[0-9]+>)/gm).filter((emptyToken) => emptyToken).map((token) => {
            if (token.match(/<[0-9]*>[^<>;]*<\/[0-9]*>/)) {
                // From <> opening/closing html tag extract the placeholder order number
                const placeholderIdx = token.substring(token.indexOf("<") + 1, token.indexOf(">"));
                return { token, isPlaceholder: true, placeholderIdx: parseInt(placeholderIdx, 0) };
            }
            else {
                return { token, isPlaceholder: false, placeholderIdx: -1 };
            }
        });
    }
}
exports.Trans = Trans;
